import request from './base/api';

export function fetchCheckInList(
  { course_id, date, branch_id, schedule_time_id, sortBy, sortType },
  cb,
  errCb
) {
  return request({
    url: `course/${course_id}/check-in`,
    method: 'get',
    config: {
      params: {
        date,
        branch_id,
        schedule_time_id: schedule_time_id,
        sortBy,
        sortType
      }
    },
    cb,
    errCb
  });
}

export function courseCheckIn(
  { course_id, date, schedule_time_id, member_no },
  cb,
  errCb
) {
  return request({
    url: `course/${course_id}/check-in`,
    method: 'post',
    config: {
      data: {
        date,
        schedule_time_id: schedule_time_id,
        member_no
      }
    },
    cb,
    errCb
  });
}

export function courseNonMemberCheckIn(
  { course_id, date, schedule_time_id, member_name, member_phone },
  cb,
  errCb
) {
  return request({
    url: `course/${course_id}/non-member-check-in`,
    method: 'post',
    config: {
      data: {
        date,
        schedule_time_id,
        member_name,
        member_phone
      }
    },
    cb,
    errCb
  });
}

export default {
  fetchCheckInList,
  courseCheckIn,
  courseNonMemberCheckIn
};
